export default __webpack_public_path__ + "dc43679a0f19074adc857c96ad4ab5cd.png";